/**
 * EB 平台静态路由（由 EB view/admin router/modules 批量转换）
 * path 统一带 ${roterPre} 前缀，与 settings.roterPre、菜单 path 对齐
 */
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';
import Layout from '@/layout/index.vue';
import { ADMIN_DASHBOARD_PATH } from '@/config/admin-route';
import merchantRouter from './merchant';
import accountsRouter from './accounts';
import appRouter from './app';
import businessZonesRouter from './businessZones';
import cmsRouter from './cms';
import communityRouter from './community';
import configRouter from './config';
import deliveryRouter from './delivery';
import freightRouter from './freight';
import groupRouter from './group';
import maintainRouter from './maintain';
import marketingRouter from './marketing';
import orderRouter from './order';
import productRouter from './product';
import promoterRouter from './promoter';
import safeRouter from './safe';
import serviceRouter from './service';
import settingRouter from './setting';
import stationRouter from './station';
import statisticRouter from './statistic';
import systemFormRouter from './systemForm';
import userRouter from './user';
import userFeedbackRouter from './userFeedback';
// sms / routine：无 views 页面，见 config/eb-excluded-routes.ts

export const crmebModuleRoutes: RouteRecordRaw[] = [
  // 若依遗留 /index → EB 控制台
  {
    path: '/index',
    redirect: ADMIN_DASHBOARD_PATH,
    hidden: true,
  },
  {
    path: `${roterPre}/index`,
    redirect: ADMIN_DASHBOARD_PATH,
    hidden: true,
  },
merchantRouter,
accountsRouter,
appRouter,
businessZonesRouter,
cmsRouter,
communityRouter,
configRouter,
deliveryRouter,
freightRouter,
groupRouter,
maintainRouter,
marketingRouter,
orderRouter,
productRouter,
promoterRouter,
safeRouter,
serviceRouter,
settingRouter,
stationRouter,
statisticRouter,
systemFormRouter,
userRouter,
userFeedbackRouter,
  {
    path: `${roterPre}`,
    component: Layout,
    redirect: `${roterPre}/dashboard`,
    children: [
      {
        path: `${roterPre}/dashboard`,
        component: () => import('@/views/dashboard/index.vue'),
        name: 'Index',
        meta: { title: '控制台', icon: 'dashboard' },
      },
    ],
  },
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
        hidden: true,
    },
    {
        path: roterPre +'/setting/userList',
        component: () => import('@/components/userList/index.vue'),
        hidden: true,
        meta: {
            title: '用户列表',
        },
    },
    {
        path: roterPre +'/setting/uploadPicture',
        component: () => import('@/components/uploadPictures/index.vue'),
        name: 'uploadPicture',
        hidden: true,
        meta: {
            title: '图片上传',
        },
    },
    {
        path: '/setting/icons',
        component: () => import('@/components/iconFrom/index.vue'),
        name: 'icons',
        hidden: true,
    },
    {
        path: roterPre +'/setting/storeProduct',
        component: () => import('@/components/goodList/index.vue'),
        name: 'storeProduct',
        hidden: true,
    },
    {
        path: roterPre +'/setting/crossStore',
        component: () => import('@/components/crossStore/index.vue'),
        name: 'CrossStore',
        hidden: true,
    },
    {
        path: roterPre +'/setting/referrerList',
        component: () => import('@/components/referrerList/index.vue'),
        name: 'ReferrerList',
        hidden: true,
    },
    {
        path: `${roterPre}/login`,
        component: () => import('@/views/login/index.vue'),
        hidden: true,
    },
    {
        path: `${roterPre}/agent-login`,
        meta: { isAgentLogin: true },
        component: () => import('@/views/login/index.vue'),
        hidden: true,
    },
    {
        path: `${roterPre}/data-screen`,
        name: 'dataScreen',
        component: () => import('@/views/dataScreen/home.vue'),
        redirect: `${roterPre}/data-screen/index`,
        hidden: true,
        children: [
            {
                path: 'index',
                name: 'screenIndex',
                component: () => import('@/views/dataScreen/indexs/index.vue'),
                meta: {
                    title: '数据大屏',
                    isFull: true,
                },
            },
        ],
    },
];
